// removed by extract-text-webpack-plugin
module.exports = {"InfoLinkContainer":"InfoLink__InfoLinkContainer__1bEam","InfoLink":"InfoLink__InfoLink__1ekLY"};